export const TOKEN = 'auth:token';

export const TOKENLOCAL = {
  tokenlocal: 'auth:tokenlocal'
}

export const MODULOS_STORAGE = {
  modulos: 'permitidos',
};

export const USER_STORAGE = {
  usesenha: 'use-senha',
  localtoken: 'localtoken',
  useidnuvem: 'user:useidnuvem',
  useidusuario: 'user:useidusuario',
  userId: 'id-usuario',
};

export const VENDEDOR_STORAGE = {
  vensenha: 'vendedor-senha',
  localtoken: 'localtoken',
  venidnuvem: 'ven:venidnuvem',
  venidvendedor: 'ven:Idvendedor',
  vendeorId: 'id-vendedor',
};

export const PRODUTO_STORAGE = {
  createFrom: 'produto:create-from',
  createBefore: 'produto:create-before',
  parametro: 'produto:parametro',
  page: 'produto:page',
  sort: 'produto:sort',
  search: 'produto:search',
  textofiltro: 'produto:textofiltro',
};

export const PESQUISA_STORAGE = {
  createFrom: 'pesquisa:create-from',
  createBefore: 'pesquisa:create-before',
  parametro: 'pesquisa:parametro',
  page: 'pesquisa:page',
  sort: 'pesquisa:sort',
  search: 'pesquisa:search',
  textofiltro: 'pesquisa:textofiltro',
};

export const PESQUISA_CADASTRO_CLIENTE_STORAGE = {
  createFrom: 'pesquisa-cadastro-cliente:create-from',
  createBefore: 'pesquisa-cadastro-cliente:create-before',
  parametro: 'pesquisa-cadastro-cliente:parametro',
  page: 'pesquisa-cadastro-cliente:page',
  sort: 'pesquisa-cadastro-cliente:sort',
  search: 'pesquisa-cadastro-cliente:search',
  textofiltro: 'pesquisa-cadastro-cliente:textofiltro',
};

export const CADASTRO_PEDIDO_PRODUTO_STORAGE = {
  createFrom: 'cadastro-pedido-produto:create-from',
  createBefore: 'cadastro-pedido-produto:create-before',
  parametro: 'cadastro-pedido-produto:parametro',
  page: 'cadastro-pedido-produto:page',
  sort: 'cadastro-pedido-produto:sort',
  search: 'cadastro-pedido-produto:search',
  textofiltro: 'cadastro-pedido-produto:textofiltro',
};

